// Shared inner body for the Oscar account wish-lists list page. Renders inside
// AccountPageBody (the account side-nav shell) without the document chrome --
// each site wraps this in its own PageSkeleton so the DOM is byte-identical to
// the pre-move AccountPageShell.
import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { AccountPageBody } from "../AccountPageBody";

type IProps = Immutable<templates.WishListListDocumentTemplate>;

export const WishListListBody = (props: IProps): React.JSX.Element => {
    const {
        wishlists,
        empty_message,
        create_url,
        create_label,
        name_label,
        count_label,
        action_label,
        view_label,
        settings_label,
        copy_link_label,
        delete_label,
    } = props;
    return (
        <AccountPageBody sideNav={props.side_nav}>
            {wishlists.length > 0 ? (
                <table className="table table-striped table-bordered">
                    <tbody>
                        <tr>
                            <th>{name_label}</th>
                            <th>{count_label}</th>
                            <th>{action_label}</th>
                        </tr>
                        {wishlists.map((wishlist, i) => (
                            <tr key={i}>
                                <td>
                                    <a href={wishlist.detail_url}>
                                        {wishlist.name}
                                    </a>
                                </td>
                                <td>{wishlist.line_count}</td>
                                <td>
                                    <div className="btn-group">
                                        <a
                                            className="btn btn-secondary"
                                            href={wishlist.detail_url}
                                        >
                                            {view_label}
                                        </a>
                                        <button
                                            className="btn btn-secondary dropdown-toggle"
                                            data-toggle="dropdown"
                                        ></button>
                                        <div className="dropdown-menu">
                                            <a
                                                href={wishlist.settings_url}
                                                className="dropdown-item"
                                            >
                                                {settings_label}
                                            </a>
                                            {wishlist.is_shareable && (
                                                <a
                                                    href={wishlist.shared_url}
                                                    className="dropdown-item clipboard-item"
                                                >
                                                    {copy_link_label}
                                                </a>
                                            )}
                                            <a
                                                href={wishlist.delete_url}
                                                className="dropdown-item"
                                            >
                                                {delete_label}
                                            </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <p>{empty_message}</p>
            )}

            <p>
                <a href={create_url} className="btn btn-primary">
                    {create_label}
                </a>
            </p>
        </AccountPageBody>
    );
};
